import axios from "@/services/api/utils/interceptors";
import { AxiosError } from "axios";

export default async (phone: string): Promise<any> => {
  try {
    const url = `/api/auth/restore`;

    const res = await axios.post(url, { phone });
    return {
      status: res.status,
    };
  } catch (err) {
    // console.warn(err.response)
    const Error = err as AxiosError;
    return {
      data: Error.response?.data,
      status: Error.response?.status,
    };
  }
};
